import { MapTo } from '@adobe/aem-react-editable-components';
import FaqTopic, { FaqTopicEditConfig } from './FaqTopic';

export default MapTo('cob-corp-acquisition/components/creditonebank/faq-topic')(FaqTopic, FaqTopicEditConfig);